import * as Styled from './styles';

const Research = () => (
    <Styled.List>
        <li>
            <Styled.Label>MSc Research:</Styled.Label> Analysis and development of Visual Language Models applied
            to image classification with multimodal inputs (text and image).
        </li>
        <li>
            <Styled.Label>Machine Learning with IBM (Coursera):</Styled.Label> Practical application of neural
            networks and logistic regression on real-world datasets.
        </li>
        <li>
            <Styled.Label>Applied Statistics for AI:</Styled.Label> Studies in inference and probability focused
            on the interpretation of predictive models.
        </li>
    </Styled.List>
);

export default Research;
